const getPublicUrl = () => {
  if (typeof process !== "undefined" && process.env && process.env.PUBLIC_URL) {
    return process.env.PUBLIC_URL;
  }

  return "";
};

export default getPublicUrl;
